const mapStateToProps = (state) => {
  return {
    isSidebarOpen: state.isSidebarOpen
  }
}

export default mapStateToProps
